import React from 'react';
import {
    Box,
    Typography,
    Container,
    Divider,
    Paper,
    createTheme,
} from '@mui/material';
import { Margin } from '@mui/icons-material';
import { Trans, useTranslation } from 'react-i18next';
import MainRouteFooter from './routes/MainRouteFooter';

function PrivacyPolicy({ screenWidth, defaultTheme }) {
    const { t } = useTranslation();
    const sections = Array.from({ length: 12 }, (_, i) => i + 1);
    return (
        <>
            <Box sx={{ bgcolor: '#f5fdf7', py: { xs: 4, md: 6 } }}>
                <Container sx={{maxWidth:'800px'}}>
                    {/* <Paper elevation={3} sx={{ p: { xs: 3, md: 5 }, borderRadius: 3 }}> */}
                    <Typography
                        variant="h4"
                        component="h1"
                        align="center"
                        gutterBottom
                        sx={{ fontWeight: 700, color: 'success.main' }}
                    >
                        {t('privacy.title')}
                    </Typography>
                    <Typography
                        variant="subtitle1"
                        align="center"
                        color="text.secondary"
                        gutterBottom
                    >
                        {t('privacy.updated')}
                    </Typography>
                    <Divider sx={{ my: 3 }} />

                    <Box>
                        <Typography variant="body1" paragraph>
                            <Trans i18nKey="privacy.intro" components={{ strong: <strong /> }} />
                        </Typography>

                        {sections.map((n) => (
                            <React.Fragment key={n}>
                                <Typography variant="subtitle1" fontWeight="bold">{t(`privacy.section${n}_title`)}</Typography>
                                <Typography variant="body1" paragraph>
                                    <Trans i18nKey={`privacy.section${n}_body`} components={{ li: <li />, br: <br />, strong: <strong /> }} />
                                </Typography>
                            </React.Fragment>
                        ))}

                        <Typography variant="subtitle1" fontWeight="bold">{t('privacy.disclaimer_title')}</Typography>
                        <Typography variant="body1" paragraph>
                            {t('privacy.disclaimer_body')}
                        </Typography>
                    </Box>
                    {/* <Divider sx={{ my: 4 }} />
                    <Typography variant="body2" color="text.secondary">
                        © {new Date().getFullYear()} Let's Go Low Carbon. สงวนลิขสิทธิ์ตามกฎหมายลิขสิทธิ์
                    </Typography> */}
                    {/* </Paper> */}
                </Container>
            </Box>
            <Divider sx={{ my: 0 }} />
            <Box sx={{ bgcolor: '#f5fdf7', }}>
                <MainRouteFooter />
            </Box>

        </>
    )
}

export default PrivacyPolicy